import {Component, Input, OnInit} from '@angular/core';
import {FlatArea} from '../../../models/flat-area.model';

@Component({
  selector: 'app-flat-area-type-selector',
  templateUrl: './flat-area-type-selector.component.html',
  styleUrls: ['./flat-area-type-selector.component.scss']
})
export class FlatAreaTypeSelectorComponent implements OnInit {

  @Input() flatArea: FlatArea;
  areaTypes: string[] = [
    'előtér', 'wc', 'fürdő', 'konyha-étkező', 'nappali', 'szoba', 'terasz', 'háztartási', 'közlekedő', 'iroda', 'öltöző', 'gardrób', 'zuhanyzó'
  ];

  constructor() {
  }

  ngOnInit() {
  }

}
